import EventProvider from "../EventProvider";

const useDispatch = () => {
  return EventProvider.dispatch.bind(EventProvider);
};

export default useDispatch;
